<div class="row page-titles">
    <div class="col-md-5 align-self-center">
        <h3 class="text-themecolor">Barsit</h3>
    </div>

</div>
<app-camera *ngIf="testData.camera" [testData]="testData" [trigger]="trigger"></app-camera>

<div class="row">
    <div class="col-12">
        <div class="card">
            <div class="card-body">
                <div *ngIf="texts" #instructions class="m-b-30"></div>

                <div class="row justify-content-center">

                    <div class="col-12">
        
                        <button class="btn waves-effect  btn-rounded btn-info mx-2 mx-2" (click)="reload()">Cancelar</button>
                        <button type="button" [disabled]="scholarship=='default'" class="btn waves-effect waves-light btn-rounded btn-info pull-right" (click)="startTest()" data-toggle="modal" data-target="#myModal" > Realizar test </button>
                    </div>
                    <div class="col-md-1"></div>
                    <div class="col-md-5">
                        <div  >
                            <label class="control-label">Nivel de escolaridad</label>
                            <select [(ngModel)]="scholarship" (change)="setScholarship($event)" class="form-control custom-select">
                                <option selected disabled value="default">Seleccione una opción</option>
                                <option value="primaria">Primaria</option>
                                <option value="secundaria">Secundaria</option>
                            </select>
                        </div>
                    </div>

                </div>
                
                        
                            <!-- sample modal content -->
                            <div id="myModal" data-backdrop="static" data-keyboard="false" class="modal fade" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" style="display: none;" aria-hidden="true">
                                <div class="modal-dialog modal-lg">
                                    <div class="modal-content ">
                                        <div class="modal-header">
                                            <h4 class="modal-title" id="myModalLabel">Barsit</h4>
                                        </div>
                                        <div *ngIf="selectedQuestion" class="modal-body">
                                            <div *ngIf="selectedQuestion.type=='text'">

                                                <h4>Seleccione una opción</h4>
    
                                                <p>{{selectedQuestion.title}}</p>
                                                <div class="col">
                                                    <button type="button" class="btn btn-block btn-lg btn-info" (click)="selectText('A')" >{{selectedQuestion.opcA.text}}</button>
                                                    <br>
                                                </div>
                                                <div class="col">
                                                    <button type="button" class="btn btn-block btn-lg btn-info" (click)="selectText('B')" >{{selectedQuestion.opcB.text}}</button>
                                                    <br>
                                                </div>
                                                <div class="col">
                                                    <button type="button" class="btn btn-block btn-lg btn-info" (click)="selectText('C')" >{{selectedQuestion.opcC.text}}</button>
                                                    <br>
                                                </div>
                                                <div class="col">
                                                    <button type="button" class="btn btn-block btn-lg btn-info" (click)="selectText('D')" >{{selectedQuestion.opcD.text}}</button>
                                                    <br>
                                                </div>
                                                <div class="col">
                                                    <button type="button" class="btn btn-block btn-lg btn-info" (click)="selectText('E')" >{{selectedQuestion.opcE.text}}</button>
                                                    <br>
                                                </div>

                                            </div>
                                            <div *ngIf="selectedQuestion.type=='number'">

                                                <h4>Ingrese los valores correctos</h4>
    
                                                <p>{{index+1}}-{{selectedQuestion.title}}</p>
                                                <div class="col-md-12">
                                                    <div class="row">
                                                        <div *ngFor="let n of selectedQuestion.numbers" class="col-sm-2">
                                                            <p *ngIf="n!=0">
                                                                {{n}}
                                                            </p>
                                                            <p *ngIf="n==0">
                                                                _
                                                            </p>
                                                        </div>
                                                    </div>

                                                </div>

                                                
                                                <div class="col-md-12">    
                                                    <div class="form-group">
                                                        <div class="row">
                                                            <div class="col-sm-6">
                                                                <label class="control-label">Primer número</label>
                                                                <input [(ngModel)]="numbers[0]" [ngModelOptions]="{standalone: true}" type="number"  class="form-control"  >
                                                            </div>
                                                            
                                                            <div class="col-sm-6">
                                                                <label class="control-label">Segundo número</label>
                                                                <input [(ngModel)]="numbers[1]" [ngModelOptions]="{standalone: true}" type="number"  class="form-control"  >
                                                            </div>
                                                            
                                                        </div>
                                                        
                                                        <div class="modal-footer">
                                                            <button type="button" (click)="selectNumber()" class="btn btn-info waves-effect" >Siguiente</button>
                                                        </div>

                                                    </div>
                                                </div>
                


                                            </div>
                                        </div>
                                        
                                    </div>
                                    <!-- /.modal-content -->
                                </div>
                                <!-- /.modal-dialog -->
                            </div>
                            <!-- /.modal -->
                      
               
            </div>
        </div>
    </div>
</div>


    <button *ngIf="onTest" class="right-side-toggle waves-effect waves-light btn-inverse btn">{{9-minutes}}:{{59-seconds | number:'2.0'}}</button>
